import { Button } from "@/components/ui/button";
import { Download, Upload, FileText, LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { exportDashboardToPDF } from "@/utils/pdfExport";
import { toast } from "sonner";
import { useTranslation } from "@/contexts/LanguageContext";
import { useAuth } from "@/hooks/useAuth";
import { useUserProfile } from "@/hooks/useUserProfile";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function DashboardHeader() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAuth();
  const { profile, tenant } = useUserProfile();

  const handleExportPDF = async () => {
    try {
      const dashboardElement = document.getElementById("dashboard-content");
      if (!dashboardElement) {
        toast.error("Erro ao capturar dashboard");
        return;
      }
      
      const userName = profile?.full_name || user?.email?.split('@')[0] || "Usuário";
      const companyName = tenant?.name || "Dashi";
      const companyLogo = tenant?.logo_url || undefined;
      
      await exportDashboardToPDF({
        dashboardElement,
        fileName: `dashboard-${new Date().toISOString().split('T')[0]}.pdf`,
        userName,
        companyName,
        companyLogo,
      });
      toast.success("PDF exportado com sucesso!");
    } catch (error) {
      toast.error("Erro ao exportar PDF");
      console.error(error);
    }
  };

  return (
    <TooltipProvider>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <LayoutDashboard className="h-8 w-8" />
          {t('dashboardTitle')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('dashboardSubtitle')}
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="outline" size="sm" onClick={() => navigate("/import")}>
              <Upload className="mr-2 h-4 w-4" />
              {t('importData')}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Importar dados de planilhas Excel</p>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="outline" size="sm" onClick={handleExportPDF}>
              <Download className="mr-2 h-4 w-4" />
              {t('exportPDF')}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Exportar dashboard em formato PDF</p>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="default" size="sm" className="gradient-primary" onClick={() => navigate("/reports")}>
              <FileText className="mr-2 h-4 w-4" />
              {t('generateReport')}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Criar relatório personalizado</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </div>
    </TooltipProvider>
  );
}
